enum SortDirection {
  None,
  Ascending,
  Descending,
}

export default SortDirection;
